export enum ReportReason {
  Sexual = 'sexual',
  Offensive = 'offensive',
  Spam = 'spam',
  Inappropriate = 'inappropriate',
  Other = 'other',
}

export const ReportReasons = {
  [ReportReason.Sexual]: 'Sexual content',
  [ReportReason.Offensive]: 'Offensive content',
  [ReportReason.Spam]: 'Spam or misleading',
  [ReportReason.Inappropriate]: 'Inappropriate content',
  [ReportReason.Other]: 'Other',
};
